import { customSpringAxios } from "./axios";
import axios from "axios";

export const searchStationAPI = async (data, cancelToken) => {
    let response;
    const { name } = data;
    await customSpringAxios
        .post(`/station/search?page=0&size=20`, { name }, { cancelToken })
        .then((r) => {
            response = r.data;
        })
        .catch((error) => {
            if (axios.isCancel(error)) {
                console.error("Request canceled", error.message);
            }
        });
    return response;
};

export const searchOnlineStationsAPI = async ({ name, fromStationId = null }, cancelToken) => {
    const response = await customSpringAxios.post("/station/online/search", { name, fromStationId }, { cancelToken });
    return (response.data || []).map((s) => ({ ...s, name: s.stationName || s.name }));
};

export const getArrivalStationsByDepartureId = async (depId) => {
    const response = await customSpringAxios.get(`/station/arrival/${depId}`);
    return response.data;
};

// Stanice između kojih se NA DATI DATUM stvarno može kupiti karta (polasci sa
// alotmanom operatera; opId upisuje bussoft proxy). Bez fromStationId vraća
// polazne, sa njim dolazne. Odgovor mapiramo na oblik {id, name} koji ceo app
// već koristi (procedura vraća stationName).
export const getOnlineStationsAPI = async ({ journeyDate, fromStationId = null }) => {
    const response = await customSpringAxios.post("/station/online", { journeyDate, fromStationId });
    return (response.data || []).map((s) => ({ ...s, name: s.stationName || s.name }));
};
